import { Flight, Traveler } from './../../shared';
import { IApiAcknowledgement } from '@bhtp-client-api/base';
import { PackageDetails } from '@bhtp-client-api/purchase';

export class FlightDataContainer {
    public acknowledgements: Array<IApiAcknowledgement>;
    public travelers: Array<Traveler>;
    public flights: Array<Flight>;
    public package: PackageDetails;
    public numberOfFlights: number;
    public validateFlights: boolean;
    public validateFlightDates: boolean;
    public overrideRequiresFlights: boolean;
    public futureFlightsExpected: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/view-models/flights-data.model.ts